import { Button, CircularProgress, ThemeProvider, Tooltip, useTheme } from "@mui/material";
import { primaryBlue } from "utils/Themes";

import DownloadIcon from '@mui/icons-material/Download';

const DownloadButton = props => {

    const {
        title = "",
        isLoading = false,
        ...others
    } = props;

    const theme = useTheme();

    return (
        <ThemeProvider
            theme={primaryBlue}
        >
            <Tooltip
                title={title}
                arrow
            >
                <Button
                    color="primary"
                    variant={"contained"}
                    style={{
                        minWidth: "2.2em",
                        minHeight: "2.2em",
                        margin: theme.spacing(.5),
                        padding: 0
                    }}
                    {...others}
                >
                    {isLoading ? (
                        <CircularProgress
                            size={20}
                            style={{
                                color: "white"
                            }}
                        />
                    ) : (
                        <DownloadIcon
                            fontSize={"small"}
                        />
                    )}
                </Button>
            </Tooltip>
        </ThemeProvider>
    );
}

export default DownloadButton;